import React from 'react'
import { Grid, IconButton, ListItem, ListItemText } from '@mui/material'
import LaunchIcon from '@mui/icons-material/Launch'

interface RoleItemProps {
  id: number
  primary: string
  secondary?: string
  redirectHandler: () => void
}

export const RoleItem: React.FC<RoleItemProps> = ({
  id,
  primary,
  secondary,
  redirectHandler
}) => {
  return (
    <ListItem
      key={id}
      sx={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}
    >
      <Grid container alignItems="center">
        <Grid item xs>
          <ListItemText
            primary={primary}
            secondary={secondary}
          />
        </Grid>
        <Grid item xs={'auto'} sx={{ textAlign: 'right' }}>
          <IconButton onClick={redirectHandler}>
            <LaunchIcon />
          </IconButton>
        </Grid>
      </Grid>
    </ListItem>
  )
}
